export const styles = theme => ({
  attendeeChip: { marginRight: 5, marginBottom: 5 },
  avatar: { color: '#fff', marginRight: theme.spacing.unit },
  expandSummary: { alignItems: 'center', display: 'flex', flexGrow: 1 },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/views/CourseList/CoursePanel/styles.js